export const planetdata = [
  {
    title: 'MOON',
    planetImg:
      'https://res.cloudinary.com/soyousay/image/upload/v1657446587/space_tours/Destinations/image-moon_mdz89x.webp',
    alt: 'moon',
    bodyText:
      "See our planet as you've never seen it before. A perfect relaxing trip away to help regain perspective and come back refreshed. While you’re there, take in some history by visiting the Luna 2 and Apollo 11 landing sites. ",
    aveDistance: '384,400 km',
    estTime: '3 days',
  },
  {
    title: 'MARS',
    planetImg:
      'https://res.cloudinary.com/soyousay/image/upload/v1657446586/space_tours/Destinations/image-mars_qwhcwl.webp',
    alt: 'mars',
    bodyText:
      'Don’t forget to pack your hiking boots. You’ll need them to tackle Olympus Mons, the tallest planetary mountain in our solar system. It’s two and a half times the size of Everest!',
    aveDistance: '225 mil. km',
    estTime: '9 months',
  },
  {
    title: 'EUROPA',
    planetImg:
      'https://res.cloudinary.com/soyousay/image/upload/v1657446586/space_tours/Destinations/image-europa_dsrl7p.webp',
    alt: 'europa',
    bodyText:
      'The smallest of the four Galilean moons orbiting Jupiter, Europa is a winter lover’s dream. With an icy surface, it’s perfect for a bit of ice skating, curling, hockey, or simple relaxation in your snug wintery cabin. ',
    aveDistance: '628 mil. km',
    estTime: '3 years',
  },
  {
    title: 'TITAN',
    planetImg:
      'https://res.cloudinary.com/soyousay/image/upload/v1657446587/space_tours/Destinations/image-titan_rfcw5q.webp',
    alt: 'titan',
    bodyText:
      ' The only moon known to have a dense atmosphere other than Earth, Titan is a home away from home (just a few hundred degrees colder!). As a bonus, you get striking views of the Rings of Saturn.',
    aveDistance: '1.6 bil. km',
    estTime: '7 years',
  },
];
